import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";

function VideoPlayer(props) {
    const { src, poster, controls, autoplay, muted, loop } = props;
    const [isLoading, setIsLoading] = useState(true);
    const [isPlaying, setIsPlaying] = useState(false);
    const [isMuted, setIsMuted] = useState(muted);
    const [hasDefaultControls, setHasDefaultControls] = useState();
    const [hasCustomControls, setHasCustomControls] = useState(false);
    const videoplayer = useRef();

    useEffect(() => {
        if (autoplay) {
            setIsPlaying(true);
            setIsMuted(true);
        }
    }, [autoplay]);

    useEffect(() => {
        switch (controls) {
            case "none":
                setHasDefaultControls(false);
                setHasCustomControls(false);
                break;
            case "custom":
                setHasDefaultControls(false);
                setHasCustomControls(true);
                break;
            default:
                setHasDefaultControls(true);
                setHasCustomControls(false);
        }
    }, [controls]);

    useEffect(() => {
        if (!isPlaying) {
            videoplayer.current.pause();
        } else {
            videoplayer.current.play();
        }
    }, [isPlaying]);

    return (
        <div className="video-player">
            {hasCustomControls && (
                <div className="video-player__controls video-player__controls--bottom-right">
                    {isLoading ? (
                        <div className="loader--dual-ring" />
                    ) : (
                        <>
                            <button
                                type="button"
                                className="button-icon"
                                onClick={() => setIsPlaying(!isPlaying)}
                            >
                                <svg role="img" className="icon fill--blank">
                                    {isPlaying ? (
                                        <use xlinkHref="/_resources/themes/schellevis/img/sprite.svg#pause" />
                                    ) : (
                                        <use xlinkHref="/_resources/themes/schellevis/img/sprite.svg#play" />
                                    )}
                                </svg>
                            </button>
                            <button
                                type="button"
                                className="button-icon"
                                onClick={() => setIsMuted(!isMuted)}
                            >
                                <svg role="img" className="icon fill--blank">
                                    {isMuted ? (
                                        <use xlinkHref="/_resources/themes/schellevis/img/sprite.svg#volume_off" />
                                    ) : (
                                        <use xlinkHref="/_resources/themes/schellevis/img/sprite.svg#volume_up" />
                                    )}
                                </svg>
                            </button>
                        </>
                    )}
                </div>
            )}

            <video
                className="video"
                src={src}
                poster={poster}
                autoPlay={autoplay}
                muted={isMuted}
                loop={loop}
                controls={hasDefaultControls}
                ref={videoplayer}
                playsinline="true"
                onLoadedMetadata={() => setIsLoading(false)}
            >
                Your browser does not support the video element
            </video>
        </div>
    );
}

VideoPlayer.propTypes = {
    src: PropTypes.string.isRequired,
    poster: PropTypes.string,
    controls: PropTypes.oneOf(["default", "custom", "none"]),
    autoplay: PropTypes.bool,
    muted: PropTypes.bool,
    loop: PropTypes.bool,
};
VideoPlayer.defaultProps = {
    poster: null,
    controls: "default",
    autoplay: false,
    muted: false,
    loop: false,
};

export default VideoPlayer;
